/**
 * 基础资料管理 menuIndex: 1
 * 店铺管理 menuIndex: 2
 * 活动管理 menuIndex: 3
 * 营运数据 menuIndex: 4
 * 费用和收益 menuIndex: 5
 * 快递业务 menuIndex: 6
 */

export const mainMenu = [{
	title: '首页',
	key: 'welcome',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/welcome/Welcome'),
	icon: 'fa fa-envira'
},
{
	menuIndex: 1,
	title: '系统参数',
	key: 'sysConfigManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/sys/Config'),
	icon: 'fa fa-home'
},
{
	menuIndex: 1,
	title: '发送短信',
	key: 'sendSmsManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/sys/SendSms'),
	icon: 'fa fa-home'
},
{
	menuIndex: 1,
	title: '网点管理',
	key: 'websitesManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/worksites/WorkSitesManage'),
	icon: 'fa fa-home'
},
{
	menuIndex: 1,
	title: '工作人员管理',
	key: 'employeesManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/employees/EmployeesManage'),
	icon: 'fa fa-users'
},
{
	menuIndex: 1,
	title: '骑手/跑腿管理',
	key: 'qishouManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/users/PaotuiManage'),
	icon: 'fa fa-bicycle'
},
{
	menuIndex: 1,
	title: '微信用户管理',
	key: 'usersManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/users/UsersManage'),
	icon: 'fa fa-weixin'
},
{
	menuIndex: 1,
	title: '微信TAG管理',
	key: 'tagManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/tags/Manage'),
	icon: 'fa fa-tags'
},
{
	menuIndex: 1,
	title: '公众号菜单',
	key: 'wxMenu',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/wxmenu/index'),
	icon: 'fa fa-map-o'
},
{
	menuIndex: 4,
	title: '数据导出管理',
	key: 'export',
	component: () => import( /* webpackChunkName: "putinTongji" */ '@/views/exports/manager'),
	icon: 'fa fa-cloud-download'
},
{
	menuIndex: 4,
	title: '入库量统计',
	key: 'putinTongji',
	component: () => import( /* webpackChunkName: "putinTongji" */ '@/views/tongji/Putin'),
	icon: 'fa fa-codepen'
},
{
	menuIndex: 4,
	title: '派件量统计',
	key: 'paijianTongji',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/tongji/Paijian'),
	icon: 'fa fa-area-chart'
},
{
	menuIndex: 5,
	title: '网点信息通知费',
	key: 'xinxifei',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/tongji/Xinxifei'),
	icon: 'fa fa-paper-plane'
},
{
	menuIndex: 5,
	title: '线上寄件费统计',
	key: 'jijianTongji',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/tongji/Jijianfei'),
	icon: 'fa fa-money'
},
{
	menuIndex: 5,
	title: '网点跑腿收益统计',
	key: 'paotuiTongji',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/tongji/Paotuifei'),
	icon: 'fa fa-money'
},
{
	menuIndex: 5,
	title: '信息通知费统计',
	key: 'smsFreightTongji',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/tongji/SmsCost'),
	icon: 'fa fa-line-chart'
},
{
	menuIndex: 4,
	title: '跑腿单出库补录',
	key: 'paotuiFeeFix',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/tongji/PaotuiFeeFix'),
	icon: 'fa fa-money'
},
{
	menuIndex: 6,
	title: '取件植入广告',
	key: 'wxMsgAdv',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/wxMsgAdvs/index'),
	icon: 'fa fa-bullhorn'
},
{
	menuIndex: 4,
	title: '发送推文',
	key: 'wxArticlManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/wxArticle/SendArticle'),
	icon: 'fa fa-file-text-o'
},
{
	menuIndex: 4,
	title: '已发送推文列表',
	key: 'wxArticlListManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/wxArticle/Article'),
	icon: 'fa fa-list-ul'
},
{
	menuIndex: 4,
	title: '检索关键字',
	key: 'keywordManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/shops/KeywordManage'),
	icon: 'fa fa-krw'
},
{
	menuIndex: 4,
	title: '客户申请列表',
	key: 'userApplyManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/users/Apply'),
	icon: 'fa fa-krw'
},
{
	menuIndex: 5,
	title: '账户余额非空用户',
	key: 'moneyManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/users/MoneyManage'),
	icon: 'fa fa-flask'
},
{
	menuIndex: 6,
	title: '快递派件',
	key: 'express2Send',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/express2Send/ExpressToSend'),
	icon: 'fa fa-gift'
},
{
	menuIndex: 6,
	title: '快递寄件',
	key: 'expressTakeIn',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/expressTakeIn/ExpressTakeIn'),
	icon: 'fa fa-truck'
},
{
	menuIndex: 6,
	title: '跑腿订单',
	key: 'paotuiOrder',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/paotuiOrder/PaotuiOrder'),
	icon: 'fa fa-slideshare'
},
{
	menuIndex: 6,
	title: '短信查询',
	key: 'smsManage',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/smsManage/SmsManage'),
	icon: 'fa fa-envelope-open'
},
{
	menuIndex: 6,
	title: '出库签收',
	key: 'expressSign',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/express2Send/Sign'),
	icon: 'fa fa-cloud-upload'
},
{
	menuIndex: 6,
	title: '面单打印',
	key: 'expressPrint',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/expressPrint/ExpressPrint'),
	icon: 'fa fa-print'
},
{
	menuIndex: 6,
	title: '运费管理',
	key: 'freight',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/freight/ExpressFreightManage'),
	icon: 'fa fa-jpy'
},
{
	menuIndex: 5,
	title: '提现审核',
	key: 'withdrawMoney',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/withdrawMoney/WithdrawMoneyManage'),
	icon: 'fa fa-money'
},
{
	menuIndex: 6,
	title: '通知审核',
	key: 'wxnotice',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/wxnotice/WxNotice'),
	icon: 'fa fa-exclamation-triangle'
},
{
	menuIndex: 7,
	title: '小程序管理',
	key: 'boxApp',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/app/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '厂家管理',
	key: 'wmFactory',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/factories/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '代理管理',
	key: 'boxProxy',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/proxy/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '网点管理',
	key: 'wmSite',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/sites/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '柜机管理',
	key: 'wmBox',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/boxes/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '主机管理',
	key: 'wmEquipment',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/equipments/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '柜机管理员',
	key: 'wmAdminUser',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/admin/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '内部用户管理',
	key: 'wmLimitUser',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/limit/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '用户电话管理',
	key: 'wmUserPhone',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/userPhone/Manage'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '后台充值记录',
	key: 'wmLimitUserDeposit',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/limit/DepositHis'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '柜机订单',
	key: 'wmTougui',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/orders/TouguiList'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '支付订单',
	key: 'wmPay',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/orders/PayList'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '屏幕广告管理',
	key: 'wmAdv',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/advs/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: 'APP版本管理',
	key: 'wmVersion',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/versions/List'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '用户结算记录',
	key: 'wmBalanceUser',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/balances/User'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '平台订单统计',
	key: 'wmBalancePlatform',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/balances/Platform'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '网点订单统计',
	key: 'wmBalanceSite',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/balances/Site'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '柜机订单统计',
	key: 'wmBalanceBox',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/balances/Box'),
	icon: 'fa fa-adjust'
},
{
	menuIndex: 7,
	title: '优惠充值',
	key: 'wmChargeActivity',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/waimaiBoxes/chargeActivity/Manage'),
	icon: 'fa fa-adjust'
}
]

export const otherMenu = [{
	title: '详情',
	key: 'detail',
	component: () => import( /* webpackChunkName: "pages" */ '@/views/detail/Detail'),
	isMulti: true
}]

export default {
	mainMenu,
	otherMenu
}



// WEBPACK FOOTER //
// ./src/config/menu.js